import { useState } from 'react'
import MyPopup from '../Component/MyPopup'
import './AdStyles.css'

function AdBlockPopup() {
  const [isOpen, setIsOpen] = useState(true)
  return (
    <>
      <MyPopup
        isPopupOpen={isOpen}
        showCloseBtn={true}
        onClose={() => setIsOpen(false)}
        popupContent={
          <div style={{ maxWidth: '500px' }}>
            <h2 style={{ color: 'orange' }}>
              <i className='bi bi-exclamation-triangle'></i> Ad Blocker Detected
            </h2>
            <p style={{ marginTop: '20px' }}>
              It seems you are using an ad blocker. Please consider disabling it
              to support us.
            </p>
          </div>
        }
      />
    </>
  )
}

export default AdBlockPopup
